import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Loading from "react-loading";
import cn from "classnames";

import Icon from "../Icon";

import { usePhotos } from "../../hooks/usePhotos";
import { useRoles } from "../../hooks/useRoles";
import { roles } from "../../constants/roles";
import { useSource } from "../../hooks/useSource";

export default function SearchBar({
  size = "large",
  onSubmit = function () {},
  isLoading = false,
  isError = false,
}) {
  const { query } = useRouter();
  const { searchText: initialSearch } = usePhotos();
  const { setSource, source } = useSource();
  const { checkAccess } = useRoles();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    setSearchText(query?.truckId || initialSearch);
  }, [initialSearch, query]);

  const spinnerDimensions =
    size === "large" ? { width: 34, height: 34 } : { width: 24, height: 24 };

  const toggleSource = () => setSource(source === "SAP" ? "Squidex" : "SAP");

  return (
    <form
      className={cn("search__form", `search__form--${size}`, {
        "search__form--error": isError,
      })}
      onSubmit={(e) => onSubmit(e, searchText, source)}
    >
      <input
        className="search__input"
        type="text"
        placeholder="Enter a stock number..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      {checkAccess(roles.marketing) && (
        <button
          type="button"
          onClick={toggleSource}
          className={cn("button button--source-toggle", {})}
        >
          {source}
        </button>
      )}

      <button className="button button--search-submit" type="submit">
        {!isLoading ? (
          <Icon icon="magnify" />
        ) : (
          <Loading type="spin" color="#676767" {...spinnerDimensions} />
        )}
      </button>
    </form>
  );
}
